import {Component, ChangeDetectionStrategy} from '@angular/core';

import {ScoreboardComponent} from '../scoreboard.component';

@Component({
    selector: 'scoreboard',
    changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: '../scoreboard.component.html'
})
export class BasketballScoreboardComponent extends ScoreboardComponent {
	constructor() {
		super();
	}

}
